import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-default-react-imports */
import { currentOrderedPaidProductLevels, orderedProductLevels } from 'self-service-api/constants/ProductLevels';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import styled from 'styled-components';
import { currentSkuIdForProductSelector } from '../../../selectors/ProductsSelectors';
import { useAppSelector } from '../../../reducers';
import { highestPossiblePriceSelector } from '../../../selectors/PricingSelectors';
import ProductLevelSelectionButton from './ProductLevelSelectionButton';
import UnavailableProductLevelButton from './UnavailableProductLevelButton';
const ResponsiveFlex = styled.div.withConfig({
  displayName: "HubProductLevelPicker__ResponsiveFlex",
  componentId: "sc-5td3xi-0"
})(["display:flex;flex-direction:row;", ""], breakpoint.phone(_t || (_t = _`
    flex-direction: column;
  `)));

const ProductLevelSelectionButtonContainer = (_ref) => {
  let {
    productLine,
    productLevel
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["productLine", "productLevel"]);

  const skuId = useAppSelector(state => currentSkuIdForProductSelector(state, {
    productLine,
    productLevel
  }));
  const highestPossiblePrice = useAppSelector(state => skuId && highestPossiblePriceSelector(state, {
    productConfigurations: [createProductConfig({
      skuId
    })]
  }));
  if (!skuId || !highestPossiblePrice) return /*#__PURE__*/_jsx(UnavailableProductLevelButton, {});
  const highMonthlyPrice = highestPossiblePrice && highestPossiblePrice.monthly.calculatedPrice;
  return /*#__PURE__*/_jsx(ProductLevelSelectionButton, Object.assign({
    productLevel: productLevel,
    price: highMonthlyPrice
  }, rest));
};

const HubProductLevelPicker = ({
  productLine,
  ownedProductLevel,
  disabledProductLevel,
  selectedProductLevel,
  required,
  setSelectedProductLevel,
  ariaLabelledById
}) => {
  return /*#__PURE__*/_jsx(ResponsiveFlex, {
    role: "group",
    "aria-labelledby": ariaLabelledById,
    children: currentOrderedPaidProductLevels.map(productLevel => {
      const isProductLevelSelected = selectedProductLevel === productLevel;
      return /*#__PURE__*/_jsx(ProductLevelSelectionButtonContainer, {
        productLine: productLine,
        productLevel: productLevel,
        selected: isProductLevelSelected,
        disabled: orderedProductLevels.indexOf(disabledProductLevel) >= orderedProductLevels.indexOf(productLevel),
        isCurrentPlan: ownedProductLevel === productLevel,
        onClick: () => {
          if (!isProductLevelSelected) {
            setSelectedProductLevel(productLevel);
          } else if (!required) {
            setSelectedProductLevel(null);
          }
        }
      }, productLevel);
    })
  });
};

export default HubProductLevelPicker;